module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-800.woff?8ab0bbdd48f276f4ba5652b27ae59210";